import React from "react";
import TCSubmitForm from "./tc-submit/tc-submit-form.jsx";

export default class PeopleTCSubmit extends React.Component {
    render() {        
        return (
            <div>
                <TCSubmitForm params={this.props.params} timecardId={this.props.params.timecardId} role="people" />
            </div>
            );
    }
}